import { useState, useCallback } from 'react';

export type ModalType = 'delete' | 'unsavedChanges' | 'publish' | 'unpublish' | string;

interface UseModalStateReturn {
  modalState: Record<ModalType, boolean>;
  showModal: (type: ModalType) => void;
  hideModal: (type: ModalType) => void;
  toggleModal: (type: ModalType) => void;
}

export const useModalState = (initialModals: ModalType[]): UseModalStateReturn => {
  // Initialize all modals as hidden
  const initialState = initialModals.reduce((acc, modalType) => {
    acc[modalType] = false;
    return acc;
  }, {} as Record<ModalType, boolean>);

  const [modalState, setModalState] = useState<Record<ModalType, boolean>>(initialState);

  const showModal = useCallback((type: ModalType) => {
    setModalState(prev => ({ ...prev, [type]: true }));
  }, []);

  const hideModal = useCallback((type: ModalType) => {
    setModalState(prev => ({ ...prev, [type]: false }));
  }, []);

  const toggleModal = useCallback((type: ModalType) => {
    setModalState(prev => ({ ...prev, [type]: !prev[type] }));
  }, []);

  return {
    modalState,
    showModal,
    hideModal,
    toggleModal
  };
};